var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgQuizContent = function SvgQuizContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F665C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.665 14.537c1.725 1.042 2.498 3.147 1.796 5.054-.534 1.45-1.183 3.118-1.791 4.42-.607 1.304-1.467 2.875-2.235 4.216-1.01 1.766-3.124 2.538-5.037 1.901a42.97 42.97 0 0 1-8.65-3.99c-1.726-1.043-2.499-3.148-1.796-5.055.534-1.452 1.184-3.122 1.79-4.42.605-1.3 1.466-2.871 2.234-4.215 1.01-1.766 3.124-2.539 5.039-1.902a42.964 42.964 0 0 1 8.65 3.991Z",
    fill: "#fff",
    fillOpacity: 0.8,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.853 12.882c-.124-1.664-1.406-3-3.067-3.233a36.36 36.36 0 0 0-10.094 0c-1.66.233-2.942 1.57-3.066 3.234-.155 2.09-.33 4.935-.33 7.105 0 2.17.175 5.015.33 7.106.124 1.664 1.406 3 3.066 3.234 3.349.469 6.746.469 10.094 0 1.66-.233 2.943-1.57 3.067-3.234.155-2.087.33-4.927.33-7.106 0-2.178-.175-5.02-.33-7.106Zm-4.34 5.497c.47-.526.422-1.33-.106-1.797a1.284 1.284 0 0 0-1.806.105l-3.43 3.84-.689-.77a1.284 1.284 0 0 0-1.806-.107 1.268 1.268 0 0 0-.106 1.797l1.645 1.841a1.282 1.282 0 0 0 1.912 0l4.386-4.91Z",
    fill: "#fff",
    fillOpacity: 0.8
  })));
};

export default SvgQuizContent;